
export const TypeaheadFocus = () => (<angular.IDirective>{

    require: 'ngModel',
    link: (scope: any, element: JQLite, attr: any, ngModel: angular.INgModelController) => {

        // trigger the popup on 'click' because 'focus'
        // is also triggered after the item selection
        element.bind('click', () => {
            var viewValue = ngModel.$viewValue;
            // restore to null value so that the typeahead can detect a change
            if (ngModel.$viewValue === ' ') {
                ngModel.$setViewValue(null);
                // ngModel.$setModelValue(null);
            }
            // force trigger the popup
            ngModel.$setViewValue(' ');
            // set the actual value in case there was already a value in the input
            ngModel.$setViewValue(viewValue || ' ');
        });
        // compare function that treats the empty space as a match
        scope.emptyOrMatch = (actual, expected) => {
            if (expected === ' ') {
                return true;
            }
            return actual.substr(0, expected.length).toLowerCase() === expected.toLowerCase();
        };
    }
});



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/directives/typeahead-focus/typehead-focus.directive.ts